import { useContext, useReducer } from "react";
import { Outlet } from "react-router-dom";
import { requestsReducer } from "./requestsReducer";
import { requestsInitialState } from "./requestsInitialState";
import RequestsContext from "./RequestsContext";


export const useRequestsContext = () => useContext(RequestsContext)


export function RequestsProvider() {
    const [requestsState, requestsDispatch] = useReducer(
        requestsReducer,
        requestsInitialState
    )

    return (
        <RequestsContext.Provider value={{ requestsState, requestsDispatch }}>
            <Outlet />
        </RequestsContext.Provider>
    )
}
